import { useEffect, useState, useRef } from "react";
import { RootState } from "../../../../redux/reducers";
import { useSelector } from "react-redux";
// components
import { ListaDocumentos } from "./ListaDocumentos";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { useBorradorParticipantes } from "../../../../hooks/useBorradorParticipantes";
// Hooks
import { UseVerConvocatorias } from "../../../../hooks/UseVerConvocatorias";
import { useDocumentosAdministrativos } from "../../../../hooks/useDocumentosAdministrativos";
// style component
import { Button, Input, Modal, Radio, message, DatePicker } from "antd";
import { CheckCircleOutlined, DeleteOutlined, PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";
// style
import "../../Usuario.style.scss";
import { DownloadFile } from "../../../../utils/DownloadFile";
import { useNavigate } from "react-router-dom";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import { openNotification } from "../../../../utils/Notifactions";
import moment, { Moment } from "moment";
import locale from 'antd/es/date-picker/locale/es_ES';
import apiMaestras from "../../../../api/Maestras/api-maestras";
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import {
  CARTA_CONFORMACION,
  DECLARACION_RESIDENCIA,
  DECLARACION_RESIDENCIA_Y_CONFORMACION,
  FORMULARIOS_EN_LINEA,
  RELACION_PARTICIPANTES,
  esCartaDeConformacion,
  esDeclaracionDeResidencia,
  esDeclaracionUnificada,
  esFormularioEnLinea,
} from "../../../../utils/documentosGrupoConformado";


interface IProps {
  /**
   * El wizard trae su propio stepper y sus propios botones, asi que no
   * necesita ni la introduccion ni la navegacion de la pagina.
   */
  mostrarIntro?: boolean;
  mostrarNavegacion?: boolean;
  /**
   * Se avisa cuando termina de guardarse un cambio en los documentos, para
   * que lo que dependa de ellos —los avisos del wizard— se entere sin que
   * haya que pedirlo.
   */
  alCambiarDocumentos?: () => void;
}

export const PanelDocumentosAdministrativos = ({
  mostrarIntro = true,
  mostrarNavegacion = true,
  alCambiarDocumentos,
}: IProps) => {
  useSelector((state: RootState) => state.participantes);

  const { decrypt } = useEncrypt();

  const navigate = useNavigate();

  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();
  const {
    guardarArchivosAdministrativos,
    eliminarArchivo,
    consultarArchivos,
    cargarPostulacionTipoParticipante,
    documentos,
    setDocumentos,
    loading,
    guardarDeclaracionP: guardarDeclaracionSinAviso,
    guardarRelacion: guardarRelacionSinAviso,
    guardarCartaConformacion: guardarCartaSinAviso,
    guardarDeclracionGC: guardarDeclaracionGCSinAviso
  } = useDocumentosAdministrativos();

  /**
   * Envuelve un guardado para avisar cuando ya quedo escrito.
   *
   * Los formatos que se diligencian en linea guardan por su propio camino,
   * asi que sin esto los avisos del wizard no se enteraban de que la
   * declaracion o la carta acababan de quedar firmadas.
   */
  const conAviso =
    (guardar: (...args: any[]) => any) =>
    async (...args: any[]) => {
      const hecho = await guardar(...args);
      alCambiarDocumentos?.();
      return hecho;
    };

  const guardarDeclaracionP = conAviso(guardarDeclaracionSinAviso);
  const guardarRelacion = conAviso(guardarRelacionSinAviso);
  const guardarCartaConformacion = conAviso(guardarCartaSinAviso);
  const guardarDeclracionGC = conAviso(guardarDeclaracionGCSinAviso);

  const [loadingRelacion, setLoadingRelacion] = useState(false);
  const [loadingDeclaracion, setLoadingDeclaracion] = useState(false);
  /** El documento que se esta viendo en el visor, por su nombre de archivo. */
  const [documentoEnElVisor, setDocumentoEnElVisor] = useState<string>("");

  const verDocumento = (archivo: string) => {
    if (archivo) setDocumentoEnElVisor(archivo);
  };

  const [documentosUsuario, setDocumentosUsuario] = useState<any>([]);
  const [tipoParticipantePostulacion, setTipoParticipantePostulacion] = useState<string | number | null>(null);
  const [preview, setPreview] = useState<any>();
  const [file, setFile] = useState<any>();

  const getDocumentosAdministrativos = async () => {
    const { data } = await apiParticipantes.consultarDocumentosAdministrativos(decrypt(localStorage.getItem("id_postulacion")));
    setDocumentosUsuario(data.documentos_administrativos);
  }

  const getSignatureParticipante = async (firma: string, index: number) => {
    if (!firma) return;
    try {
      // Ensure we are using the filename if it's a path
      const nombreArchivo = firma.split('/').pop() || firma;
      console.log(`Consultando firma para participante ${index}:`, nombreArchivo);

      const data = await apiDocumentos.consultarArchivo(nombreArchivo);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result as string;
          setParticipantes((prev) => {
            const newParticipantes = [...prev];
            if (newParticipantes[index]) {
              newParticipantes[index] = {
                ...newParticipantes[index],
                preview: base64String
              };
            }
            return newParticipantes;
          });
        }
      }
    } catch (error) {
      console.error(`Error al obtener la firma del participante ${index}:`, error);
    }
  };

  const user = getStorageUser()

  useEffect(() => {
    getConvocatoriaPersistente();
    cargarPostulacionTipoParticipante();
    getDocumentosAdministrativos();
  }, []);

  useEffect(() => {
    const tipoParticipante = localStorage.getItem('tipo_participante_postulacion');
    if (tipoParticipante) {
      setTipoParticipantePostulacion(tipoParticipante);
    }
  }, [decrypt]);

  // Ref para rastrear si ya se procesó la combinación
  const procesadoRef = useRef(false);
  const documentosCombinadosRef = useRef<any[]>([]);

  // Combinar documentosUsuario con documentos sin duplicados por id
  useEffect(() => {
    if (documentos && documentos.length > 0) {
      const documentosMap = new Map();

      // Combinar priorizando la versión que tenga data (url_participante o fecha_firma)
      // Primero poblamos con lo que hay en documentos (vienen del hook)
      documentos.forEach((doc: any) => {
        if (doc?.id) {
          documentosMap.set(doc.id, doc);
        }
      });

      // Luego complementamos con documentosUsuario si tienen más info
      if (documentosUsuario && documentosUsuario.length > 0) {
        documentosUsuario.forEach((doc: any) => {
          if (doc?.id) {
            const existing = documentosMap.get(doc.id);
            if (existing) {
              // Si el existente no tiene firma pero este sí, usamos este
              const hasDataExisting = (existing.url_participante && existing.url_participante !== "") || (existing.fecha_firma && existing.fecha_firma !== "");
              const hasDataNew = (doc.url_participante && doc.url_participante !== "") || (doc.fecha_firma && doc.fecha_firma !== "");

              if (hasDataNew && !hasDataExisting) {
                documentosMap.set(doc.id, { ...existing, ...doc });
              }
            } else {
              // Si no existía en documentos (extraño pero posible), lo agregamos
              documentosMap.set(doc.id, doc);
            }
          }
        });
      }

      const combinados = Array.from(documentosMap.values());

      // Solo actualizar si hay cambios estructurales para evitar loops infinitos
      const idsCombinados = combinados.map((d: any) => d?.id).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b))).join(',');
      const idsActuales = documentosCombinadosRef.current.map((d: any) => d?.id).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b))).join(',');

      if (idsCombinados !== idsActuales && idsCombinados !== '') {
        documentosCombinadosRef.current = combinados;
        setDocumentosUsuario(combinados);
        procesadoRef.current = true;
      }
    }
  }, [documentos]);

  useEffect(() => {
    console.log('documentos', documentos)
    console.log('documentosUsuario', documentosUsuario)

    // Solo procesar cuando ambos arrays tengan datos y no se haya procesado ya
    if (documentos.length > 0 && documentosUsuario && documentosUsuario.length > 0) {
      // Crear una copia profunda de documentos para evitar mutaciones
      let nuevosdocumentos = documentos.map((doc: any) => ({ ...doc }));
      let hayCambios = false;

      nuevosdocumentos = nuevosdocumentos.map((documento: any) => {
        if (documento.url_participante === undefined || documento.url_participante === "") {
          const filterDocumentoAdministrativo = documentosUsuario.filter(
            (documentoAdministrativo: any) => documento.id == documentoAdministrativo.id
          );

          if (filterDocumentoAdministrativo.length > 0 && filterDocumentoAdministrativo[0]) {
            const docAdmin = filterDocumentoAdministrativo[0];

            if (docAdmin.url_participante !== "" && documento.url_participante !== docAdmin.url_participante) {
              documento.url_participante = docAdmin.url_participante;
              hayCambios = true;
            }

            if (documento.descripcion == "Declaración de Residencia" && !documento.participantes) {
              if (docAdmin.pais_residencia !== "" && documento.pais_residencia !== docAdmin.pais_residencia) {
                documento.pais_residencia = docAdmin.pais_residencia;
                hayCambios = true;
              }
              if (docAdmin.anos_residencia !== "" && documento.anos_residencia !== docAdmin.anos_residencia) {
                documento.anos_residencia = docAdmin.anos_residencia;
                hayCambios = true;
              }
              if (docAdmin.direccion !== "" && documento.direccion !== docAdmin.direccion) {
                documento.direccion = docAdmin.direccion;
                hayCambios = true;
              }
              if (docAdmin.pais !== "" && documento.pais !== docAdmin.pais) {
                documento.pais = docAdmin.pais;
                hayCambios = true;
              }
              if (docAdmin.ciudad !== "" && documento.ciudad !== docAdmin.ciudad) {
                documento.ciudad = docAdmin.ciudad;
                hayCambios = true;
              }
              if (docAdmin.comuna !== "" && documento.comuna !== docAdmin.comuna) {
                documento.comuna = docAdmin.comuna;
                hayCambios = true;
              }
              if (docAdmin.firma_declaracion !== "" && documento.firma_declaracion !== docAdmin.firma_declaracion) {
                documento.firma_declaracion = docAdmin.firma_declaracion;
                hayCambios = true;
              }
              if (docAdmin.fecha_firma !== "" && documento.fecha_firma !== docAdmin.fecha_firma) {
                documento.fecha_firma = docAdmin.fecha_firma;
                hayCambios = true;
              }
              if (docAdmin.correo !== undefined && docAdmin.correo !== "" && documento.correo !== docAdmin.correo) {
                documento.correo = docAdmin.correo;
                hayCambios = true;
              }
              if (docAdmin.telefono !== undefined && docAdmin.telefono !== "" && documento.telefono !== docAdmin.telefono) {
                documento.telefono = docAdmin.telefono;
                hayCambios = true;
              }
            }

            // Relación de participantes de la propuesta: sincronizar participantes y fecha_firma
            if (esFormularioEnLinea(documento) || (documento.participantes && documento.participantes.length > 0)) {
              // Los participantes vienen desde documentosUsuario (docAdmin), no desde documentos
              let participantesOrigen: any[] = [];
              if (Array.isArray(docAdmin.participantes)) {
                participantesOrigen = docAdmin.participantes;
              } else if (Array.isArray(documento.participantes)) {
                participantesOrigen = documento.participantes;
              }

              console.log('participantesOrigen', participantesOrigen);

              // Eliminar participantes duplicados por numeroDocumento y convertir fechas a Moment
              const seenDocs = new Set<string>();
              const participantesSinDuplicados = participantesOrigen
                .filter((p: any) => {
                  if (!p?.numeroDocumento) return true;
                  if (seenDocs.has(p.numeroDocumento)) return false;
                  seenDocs.add(p.numeroDocumento);
                  return true;
                })
                .map((p: any) => {
                  // Convertir fechaNacimiento de string a Moment si es necesario
                  if (p.fechaNacimiento && typeof p.fechaNacimiento === 'string') {
                    return {
                      ...p,
                      fechaNacimiento: moment(p.fechaNacimiento)
                    };
                  }
                  // Si ya es un objeto Moment o está en formato válido, mantenerlo
                  if (p.fechaNacimiento && !moment.isMoment(p.fechaNacimiento)) {
                    const fechaMoment = moment(p.fechaNacimiento);
                    if (fechaMoment.isValid()) {
                      return {
                        ...p,
                        fechaNacimiento: fechaMoment,
                        preview: undefined
                      };
                    }
                  }
                  return { ...p, preview: undefined };
                });

              // Guardar la lista (sin duplicados) en el documento administrativo
              if (participantesSinDuplicados.length > 0) {
                // Solo marcamos cambio si realmente varía respecto a lo que ya tiene el documento
                const actuales = Array.isArray(documento.participantes)
                  ? documento.participantes
                  : [];

                const porDocumento = (a: any, b: any) => String(a).localeCompare(String(b));

                const idsNuevos = participantesSinDuplicados
                  .map((p: any) => p.numeroDocumento)
                  .filter(Boolean)
                  .sort(porDocumento)
                  .join(',');

                const idsActuales = actuales
                  .map((p: any) => p.numeroDocumento)
                  .filter(Boolean)
                  .sort(porDocumento)
                  .join(',');

                if (idsNuevos !== idsActuales) {
                  documento.participantes = participantesSinDuplicados;
                  hayCambios = true;
                }
              }

              // Actualizar el estado local de participantes con la lista ya validada solo si hay datos
              if (participantesSinDuplicados.length > 0) {
                setParticipantes(participantesSinDuplicados);
                console.log('Procesando firmas para participantes:', participantesSinDuplicados.length);
                participantesSinDuplicados.forEach((participante: any, index: number) => {
                  // Validar que tenga firma, sea string y no tenga preview (o el preview sea inválido)
                  if (participante?.firma && typeof participante.firma === 'string') {
                    if (!participante.preview || participante.preview.startsWith('blob:')) {
                      getSignatureParticipante(participante.firma, index);
                    }
                  }
                });
              }
              console.log('participantes (estado)', participantesSinDuplicados);
              // Sincronizar la fecha_firma si viene desde documentosUsuario
              if (docAdmin.fecha_firma !== "" && documento.fecha_firma !== docAdmin.fecha_firma) {
                documento.fecha_firma = docAdmin.fecha_firma;
                hayCambios = true;
              }
            }
          }
        }
        return documento;
      });

      // Solo actualizar si hay cambios reales para evitar loops
      if (hayCambios) {
        setDocumentos(nuevosdocumentos);
      }
    }
  }, [documentosUsuario]);

  useEffect(() => {
    getLineasConvocatorias();
    setPais("MEDELLÍN");
    setCiudad(localStorage.getItem("ciudad"));
    setComuna(localStorage.getItem("comuna"));
    const u = getStorageUser();
    setCorreo(u.correo || "");
    setCelular(u.celular || "");
  }, []);



  const [openResidenciaModal, setOpenResidenciaModal] = useState(false);
  const [openRelacionParticipantesModal, setOpenRelacionParticipantesModal] = useState(false);
  const fileInputRef = useRef<any>();
  const formulariosEnLinea = FORMULARIOS_EN_LINEA;
  const selectFile = (e: any) => {
    const { type } = e.target.files[0];

    if (type !== "image/png" && type !== "image/jpeg") {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png y .jpg",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", e.target.files[0]);

    setFile(formData);
    setPreview(URL.createObjectURL(e.target.files[0]));
    setParticipante({
      ...participante,
      firma: formData,
      preview: URL.createObjectURL(e.target.files[0]),
    });
  };
  interface Participante {
    nombresApellidos: string;
    rol: string;
    tipoDocumento: string;
    numeroDocumento: string;
    fechaNacimiento: Moment | null;
    edadCumplida: number | "";
    direccionResidencia: string;
    ciudad: string;
    telefonoFijo: string;
    telefonoCelular: string;
    correoElectronico: string;
    firma?: FormData | string;
    preview?: string;
    fechaFirma?: string;
    tiempoResidencia?: number;
    nombreGrupo?: string;
  }

  /* =======================
     ESTADO INICIAL
  ======================= */
  const emptyParticipante: Participante = {
    nombresApellidos: "",
    rol: "",
    tipoDocumento: "",
    numeroDocumento: "",
    fechaNacimiento: null,
    edadCumplida: "",
    direccionResidencia: "",
    ciudad: "",
    telefonoFijo: "",
    telefonoCelular: "",
    correoElectronico: "",
  };

  const [participante, setParticipante] = useState<Participante>(
    emptyParticipante
  );

  const [participantes, setParticipantes] = useState<Participante[]>([]);

  useEffect(() => {
    if (convocatoria?.linea_estrategica === "Ley de espectáculos públicos" && participante.ciudad !== "MEDELLÍN") {
      setParticipante(prev => ({
        ...prev,
        ciudad: "MEDELLÍN"
      }));
    }
  }, [convocatoria?.linea_estrategica, participante.ciudad]);

  const calcularEdad = (fecha: Moment): number => {
    const hoy = moment();
    let edad = hoy.year() - fecha.year();
    if (
      hoy.month() < fecha.month() ||
      (hoy.month() === fecha.month() && hoy.date() < fecha.date())
    ) {
      edad--;
    }
    return edad;
  };


  const handleChange = (name: string, value: any) => {
    setParticipante(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleParticipantDataChange = (indexParticipante: number, campo: string, valor: any) => {
    let finalValue = valor;
    let extraChanges: any = {};

    if (campo === 'fechaNacimiento') {
      const edad = calcularEdad(valor);
      extraChanges['edadCumplida'] = edad;
    }

    const nuevosParticipantes = [...participantes];
    nuevosParticipantes[indexParticipante] = {
      ...nuevosParticipantes[indexParticipante],
      [campo]: finalValue,
      ...extraChanges
    };
    setParticipantes(nuevosParticipantes);
  };

  const agregarNuevoParticipante = () => {
    if (participantes.length > 0) {
      const last = participantes[participantes.length - 1];
      const incomplete = !last.nombresApellidos || !last.rol || !last.tipoDocumento || !last.numeroDocumento || !last.fechaNacimiento || !last.direccionResidencia || !last.correoElectronico;
      if (incomplete) {
        return message.warning("Debe completar todos los campos del participante actual antes de agregar uno nuevo.");
      }
    }

    const nuevoParticipante: Participante = {
      nombresApellidos: "",
      rol: "",
      tipoDocumento: "",
      numeroDocumento: "",
      fechaNacimiento: null,
      edadCumplida: "",
      direccionResidencia: "",
      ciudad: "",
      telefonoFijo: "",
      telefonoCelular: "",
      tiempoResidencia: 0,
      correoElectronico: "",
      nombreGrupo: participante.nombreGrupo || ""
    };

    setParticipantes([...participantes, nuevoParticipante]);
    message.success("Campo para nuevo participante agregado.");
  };

  const eliminarParticipante = (index: number) => {
    setParticipantes(participantes.filter((_, i) => i !== index));
    message.success("Participante eliminado");
  };

  const handleParticipantSignatureChange = (indexParticipante: number, e: any) => {
    const fileContent = e.target.files[0];
    if (!fileContent) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/jfif"];
    const extension = fileContent.name.split('.').pop()?.toLowerCase();

    if (!allowedTypes.includes(fileContent.type) && extension !== 'jfif' && extension !== 'jpg' && extension !== 'jpeg') {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png, .jpg y .jfif",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", fileContent);

    setParticipantes(prev => {
      const next = [...prev];
      next[indexParticipante] = {
        ...next[indexParticipante],
        firma: formData,
        preview: URL.createObjectURL(fileContent)
      };
      return next;
    });
  };

  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  const datosEmpresa = localStorage.getItem('datosEmpresa');

  const datosEmpresaParsed = datosEmpresa
    ? JSON.parse(datosEmpresa)
    : null;

  const [fechaFirma, setFechaFirma] = useState<string>("");

  const obtenerFechaFormateada = () => {
    const fechaActual = new Date();
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const dia = fechaActual.getDate();
    const mes = meses[fechaActual.getMonth()];
    const anio = fechaActual.getFullYear();

    const horas = fechaActual.getHours().toString().padStart(2, "0");
    const minutos = fechaActual.getMinutes().toString().padStart(2, "0");

    return `${dia} de ${mes} de ${anio} ${horas}:${minutos}`;
  };

  const disabledFechaNacimiento = (current: Moment) => {
    // Si se permiten menores, no se bloquea ninguna fecha
    if (convocatoria.menor_edad) {
      return false;
    }

    // Fecha máxima permitida = hoy - 18 años
    const fechaLimite = moment().subtract(18, "years");

    // Bloquear fechas posteriores (menores de 18)
    return current.isAfter(fechaLimite, "day");
  };

  // declaracion persona natural

  const [anosResidencia, setAnosResidencia] = useState<string>("");
  const [direccion, setDireccion] = useState<string>("");
  const [pais, setPais] = useState<string>("");
  const [ciudad, setCiudad] = useState<string>("");
  const [comuna, setComuna] = useState<string>("");
  const [correo, setCorreo] = useState<string>("");
  const [celular, setCelular] = useState<string>("");

  const normalizarTexto = (texto: string) =>
    texto
      .trim()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const firmarDeclaracion = async () => {

    if (!preview) {
      message.error("Debe actualizar la firma");
      return;
    }
    // Validar campos comunes obligatorios
    if (!direccion || direccion.trim() === "") {
      message.error("Debe ingresar la dirección");
      return;
    }

    if (!pais || pais.trim() === "") {
      message.error("Debe ingresar el país");
      return;
    }

    if (!ciudad || ciudad.trim() === "") {
      message.error("Debe ingresar la ciudad");
      return;
    }

    const ciudadNormalizada = normalizarTexto(ciudad || "");

    if (ciudadNormalizada === "MEDELLIN") {
      if (!comuna || comuna.trim() === "") {
        message.error("Debe ingresar la comuna");
        return;
      }
    }

    if (!anosResidencia) {
      message.error("Debe ingresar los años de residencia");
      return;
    }

    // Encontrar el índice del documento "Declaración de Residencia" en el array documentos
    const indexDeclaracion = documentos.findIndex(
      (doc: any) => doc.descripcion === "Declaración de Residencia"
    );

    if (indexDeclaracion === -1) {
      message.error("No se encontró el documento de declaración");
      return;
    }

    setLoadingDeclaracion(true);
    // Obtener la fecha actual formateada
    const fechaActual = obtenerFechaFormateada();
    setFechaFirma(fechaActual);

    if (file) {
      try {
        const data = await apiDocumentos.guardarArchivo(file);
        localStorage.setItem("firma", data.data);
        if (data) {
          setFile(null);

          openNotification({
            titulo: "Hecho",
            descripcion: "La firma se guardó correctamente",
            placement: "bottomRight",
          });
        }
      } catch (err) {
        console.log(err);
        throw new Error(
          "An unhandled exception has ocrrurred at handleSubmit method"
        );
      }
    }

    guardarDeclaracionP(indexDeclaracion, {
      paisResidencia: 'Colombia',
      anosResidencia: anosResidencia,
      direccion: direccion || (user?.direccion),
      pais: pais || ("Colombia"),
      ciudad: ciudad || (user?.ciudad),
      comuna: comuna || (user?.comuna),
      firma: localStorage.getItem("firma"),
      fechaFirma: fechaActual,
      correo: correo,
      telefono: celular,
      tipo_documento: user?.tipo_identificacion?.split('-')[1]
    });

    // Cerrar el modal después de firmar
    setOpenResidenciaModal(false);
    message.success("Declaración firmada correctamente, para guardar clic en continuar");
    setLoadingDeclaracion(false);
  }

  const firmarRelacion = async () => {

    setLoadingRelacion(true);

    const indexDeclaracion = documentos.findIndex(
      (doc: any) => doc.descripcion === "Relación de participantes de la propuesta"
    );

    if (indexDeclaracion === -1) {
      message.error("No se encontró el documento de relación de participantes");
      return;
    }

    if (participantes.length > 0) {
      try {
        for (const partici of participantes) {
          if (!partici.firma) continue;

          // Si la firma ya es un string (ruta/nombre), no necesitamos volver a subirla
          if (typeof partici.firma !== 'string') {
            const data = await apiDocumentos.guardarArchivo(partici.firma);
            partici.firma = data.data;
            localStorage.setItem(`firma_${partici.numeroDocumento}`, data.data);
          }
        }

        setFile(null);

        guardarRelacion(indexDeclaracion, participantes)

        openNotification({
          titulo: "Hecho",
          descripcion: "Las firmas se guardaron correctamente",
          placement: "bottomRight",
        });

        setOpenRelacionParticipantesModal(false);
        setLoadingRelacion(false);
        message.success(
          "Relación de participantes firmada correctamente, para guardar clic en continuar"
        );

      } catch (err) {
        console.error(err);
        throw new Error(
          "An unhandled exception has occurred at handleSubmit method"
        );
      }
    } else {
      message.error("No hay participantes para firmar");
      setLoadingRelacion(false);
    }

  }

  const ciudadNormalizada = normalizarTexto(ciudad || "");
  const [openRelacionCartaConformacionModal, setOpenRelacionCartaConformacionModal] = useState(false);
  const [loadingCartaConformacion, setLoadingCartaConformacion] = useState(false);

  const firmarCartaConformacion = async () => {

    let linea = getFilterLineaConvocatoria(convocatoria.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(convocatoria.linea_convocatoria)}` : ""
    console.log(linea)

    if (linea.includes('Altavoz')) {
      if (!validarParticipantesArea(participantes)) {
        message.error(
          "Al menos el 60% de los participantes deben ser de Medellín o el área metropolitana"
        );
        return;
      }
    } else if (!validarParticipantesMedellin(participantes)) {
      message.error(
        "Al menos el 60% de los participantes deben ser de Medellín"
      );
      return;
    }

    setLoadingCartaConformacion(true);

    const indexCartaConformacion = documentos.findIndex((doc: any) =>
      esCartaDeConformacion(doc)
    );

    if (indexCartaConformacion === -1) {
      message.error("No se encontró el documento de carta de conformación de grupo");
      return;
    }

    if (participantes.length > 0) {
      try {
        for (const partici of participantes.filter((p: any) => p.firma && typeof p.firma !== 'string')) {
          const data = await apiDocumentos.guardarArchivo(partici.firma);
          partici.firma = data.data;
          localStorage.setItem(`firma_${partici.numeroDocumento}`, data.data);
        }

        setFile(null);

        const participantesConGrupo = participantes.map(p => ({
          ...p,
          nombreGrupo: participante.nombreGrupo
        }));

        guardarCartaConformacion(indexCartaConformacion, participantesConGrupo)

        openNotification({
          titulo: "Hecho",
          descripcion: "Las firmas se guardaron correctamente",
          placement: "bottomRight",
        });

        setOpenRelacionCartaConformacionModal(false);
        setLoadingCartaConformacion(false);
        message.success(
          "Carta de conformación de grupo firmada correctamente, para guardar clic en continuar"
        );

      } catch (err) {
        console.error(err);
        throw new Error(
          "An unhandled exception has occurred at handleSubmit method"
        );
      }
    } else {
      message.error("No hay participantes para firmar");
      setLoadingCartaConformacion(false);
    }

  }

  const [openDeclaracionGCModal, setOpenDeclaracionGCModal] = useState(false);

  /**
   * Guarda los participantes a medida que se llenan.
   *
   * Alguien llevaba cuarenta miembros cargados, se le cerro la pagina y
   * perdio todo: hasta ahora la lista solo existia en memoria hasta que se
   * enviaba el modal. Se espera un segundo y medio tras el ultimo cambio para
   * no escribir en cada tecla, y se usa la ruta que toca un solo documento
   * para no pisar los demas.
   */
  /**
   * Como se llama la declaracion en esta convocatoria.
   *
   * Se mira en los documentos y no en una constante porque una
   * convocatoria pide el formato unificado o el anterior, nunca los dos, y
   * el borrador tiene que guardarse contra el que exista.
   */
  const descripcionDeLaDeclaracion = () =>
    documentos.some((doc: any) => esDeclaracionUnificada(doc))
      ? DECLARACION_RESIDENCIA_Y_CONFORMACION
      : DECLARACION_RESIDENCIA;

  const descripcionDelModalAbierto = () => {
    if (openRelacionParticipantesModal) return RELACION_PARTICIPANTES;
    if (openRelacionCartaConformacionModal) return CARTA_CONFORMACION;
    if (openResidenciaModal || openDeclaracionGCModal) return descripcionDeLaDeclaracion();
    return null;
  };

  useBorradorParticipantes({
    participantes,
    documentos,
    descripcion: descripcionDelModalAbierto(),
    idPostulacion: decrypt(localStorage.getItem("id_postulacion")),
  });
  const [loadingDeclaracionGC, setLoadingDeclaracionGC] = useState(false);

  const firmarDeclaracionGC = async () => {

    let linea = getFilterLineaConvocatoria(convocatoria.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(convocatoria.linea_convocatoria)}` : ""
    console.log(linea)

    if (linea.includes('Altavoz')) {
      if (!validarParticipantesArea(participantes)) {
        message.error(
          "Al menos el 60% de los participantes deben ser de Medellín o el área metropolitana"
        );
        return;
      }
    } else if (!validarParticipantesMedellin(participantes)) {
      message.error(
        "Al menos el 60% de los participantes deben ser de Medellín"
      );
      return;
    }

    setLoadingDeclaracionGC(true);

    const indexDeclaracionGC = documentos.findIndex(
      (doc: any) => esDeclaracionUnificada(doc) || esDeclaracionDeResidencia(doc)
    );

    if (indexDeclaracionGC === -1) {
      message.error("No se encontró declaración de residencia de grupo");
      return;
    }

    if (participantes.length > 0) {
      try {
        for (const partici of participantes.filter((p: any) => p.firma && typeof p.firma !== 'string')) {
          const data = await apiDocumentos.guardarArchivo(partici.firma);
          partici.firma = data.data;
          localStorage.setItem(`firma_${partici.numeroDocumento}`, data.data);
        }

        setFile(null);

        const participantesConGrupo = participantes.map(p => ({
          ...p,
          nombreGrupo: participante.nombreGrupo
        }));

        guardarDeclracionGC(indexDeclaracionGC, participantesConGrupo)

        openNotification({
          titulo: "Hecho",
          descripcion: "Las firmas se guardaron correctamente",
          placement: "bottomRight",
        });

        setOpenDeclaracionGCModal(false);
        setLoadingDeclaracionGC(false);
        message.success(
          "Declaración de residencia de grupo firmada correctamente, para guardar clic en continuar"
        );

      } catch (err) {
        console.error(err);
        throw new Error(
          "An unhandled exception has occurred at handleSubmit method"
        );
      }
    } else {
      message.error("No hay participantes para firmar");
      setLoadingDeclaracionGC(false);
    }
  }

  const validarParticipantesArea = (participantes: any[]) => {
    const total = participantes.length;

    if (total === 0) return false;

    const ciudadesPermitidas = [
      "MEDELLIN",
      "CALDAS",
      "LA ESTRELLA",
      "LAESTRELLA",
      "ESTRELLA",
      "SABANETA",
      "ENVIGADO",
      "ITAGUI",
      "BELLO",
      "COPACABANA",
      "GIRARDOTA",
      "BARBOSA"
    ];

    const participantesMedellin = participantes.filter(p => {
      const ciudadTexto = normalizarTexto(p.ciudad);
      // Removemos todos los espacios en blanco del texto del usuario (opcional si escriben LAESTRELLA vs LA ESTRELLA)
      const ciudadSinEspacios = ciudadTexto.replace(/\s+/g, "");

      return ciudadesPermitidas.includes(ciudadTexto) || ciudadesPermitidas.includes(ciudadSinEspacios);
    }).length;

    const minimoRequerido = Math.ceil(total * 0.6);

    return participantesMedellin >= minimoRequerido;
  };

  const validarParticipantesMedellin = (participantes: any[]) => {
    const total = participantes.length;

    if (total === 0) return false;

    const ciudadesPermitidas = [
      "MEDELLIN"
    ];

    const participantesMedellin = participantes.filter(p => {
      const ciudadTexto = normalizarTexto(p.ciudad);
      // Removemos todos los espacios en blanco del texto del usuario (opcional si escriben LAESTRELLA vs LA ESTRELLA)
      const ciudadSinEspacios = ciudadTexto.replace(/\s+/g, "");

      return ciudadesPermitidas.includes(ciudadTexto) || ciudadesPermitidas.includes(ciudadSinEspacios);
    }).length;

    const minimoRequerido = Math.ceil(total * 0.6);

    return participantesMedellin >= minimoRequerido;
  };

  return (
    <div>
      <div className="container-fluid2">
        {mostrarIntro && (
        <div className="row mt-4">
          <div className="col-12 no-margin font-family-Montserrat-Regular font-size-18px">
            <span className="font-family-Montserrat-SemiBold">
              ¡Ya casi terminamos! Carga los siguientes formatos PDF de documentación administrativa.
            </span>{" "}
            ¡Por favor completa los siguientes datos! Recuerda cargar la documentación solicitada en este paso, es importante para el proceso de postulación.
          </div>
        </div>
        )}
        <div className="col-12 mt-4">
          <div className="row">
            <div className="col-2 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion background-seleccionar-postulacion-verde">
              3
            </div>
            <div className="col font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Documentación Administrativa.
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid2">
        <div className="row mt-4">
          <div className="col-12 mb-3">
            <span className="font-family-Montserrat-SemiBold font-size-14px mb-2 d-block">
              Tipo de participante
            </span>
            <Input
              style={{ width: "100%" }}
              disabled
              value={
                (() => {
                  const t = tipoParticipantePostulacion;
                  if (t == 0) return "Persona Natural";
                  if (t == 1) return "Persona Jurídica";
                  if (t == 2) return "Grupo Conformado";
                  return "";
                })()
              }
            />
          </div>
        </div>
        <ListaDocumentos
          acciones={{
            documentos,
            documentosUsuario,
            setDocumentosUsuario,
            // Se envuelven para avisar cuando el cambio ya quedo guardado y
            // no cuando cambia el estado de la pantalla: la escritura va
            // despues, y los avisos releen del servidor.
            guardarArchivosAdministrativos: async (...args: any[]) => {
              const hecho = await guardarArchivosAdministrativos(
                ...(args as [any, any, number])
              );
              alCambiarDocumentos?.();
              return hecho;
            },
            eliminarArchivo: async (...args: any[]) => {
              const hecho = await eliminarArchivo(...(args as [any, number, any]));
              alCambiarDocumentos?.();
              return hecho;
            },
            DownloadFile,
            verDocumento,
            formulariosEnLinea,
            setOpenResidenciaModal,
            setOpenRelacionParticipantesModal,
            setOpenRelacionCartaConformacionModal,
            setOpenDeclaracionGCModal,
            setParticipante,
            setParticipantes,
            setCelular,
            setCorreo,
          }}
        />
      </div>
      {mostrarNavegacion && (
      <div
        className="container-fluid2 bg-white"
        style={{
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0%",
        }}
      >
        <div className="col justify-content-flex-end">
          <Button
            style={{ marginRight: "1%" }}
            type="link"
            className="button-blanco-radius font-size-12px"
            disabled={loading}
            onClick={
              () => {
                consultarArchivos(true)
              }
            }
          >
            Guardar y salir
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
          <Button
            style={{ marginRight: "1%" }}
            type="link"
            className="button-blanco-radius font-size-12px"
            onClick={() => navigate("/usuario/seleccionarCategoria")}
          >
            Atrás
          </Button>
          <Button
            type="link"
            className="button-azul-radius font-size-12px"
            onClick={() => consultarArchivos(false)}
            disabled={loading}
          >
            Continuar
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
        </div>
      </div>
      )}
      <Modal
        style={{ top: 20, zIndex: 3 }}
        visible={openResidenciaModal}
        footer={null}
        width={800}
        maskClosable={true}
        onCancel={() => setOpenResidenciaModal(false)}
        maskStyle={{
          zIndex: 3,
          background: "rgb(12, 164, 93)",
        }}
        className="modal-postulacion-exitosa"
      >
        <div className="document-wrapper">
          <div id="modal_custom" className="document-page">

            <h3 className="text-center">
              DECLARACIÓN JURAMENTADA DE RESIDENCIA
            </h3>
            <p className="text-justify">
              Señores, <br />
              {convocatoria.entidad === 'SM' ? (
                <>
                  <strong>Convocatoria Estímulos a los Talentos y Liderazgos de las Mujeres</strong> <br />
                  Secretaría de las Mujeres <br />
                </>
              ) : (
                <>
                  <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                  Secretaría de Cultura Ciudadana <br />
                </>
              )}
              Alcaldía de Medellín <br />
              Distrito de Ciencia, Tecnología e Innovación
            </p>
            <br />
            <p className="text-justify">
              Yo, <strong>{user?.nombres} {user?.apellidos}</strong>, identificado(a) con{" "}
              <strong> {user?.tipo_identificacion?.split('-')[1]}</strong> número{" "}
              <strong> {user?.documento}</strong>, manifiesto bajo{" "}
              gravedad de juramento que mi lugar de residencia es
              <Input
                value={pais}
                onChange={(e) => setPais(e.target.value)}
                placeholder="Ingrese Ciudad"
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
              {" "} y lo ha sido durante los
              últimos{" "}
              <Input
                type="number"
                value={anosResidencia}
                onChange={(e) => {
                  const val = e.target.value;
                  if (Number(val) < 0) return;
                  setAnosResidencia(val);
                }}
                onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                    e.preventDefault();
                  }
                }}
                placeholder="Años"
                min={2}
                style={{ display: "inline-block", width: "80px", margin: "0 5px" }}
              />{" "}
              años.
            </p>
            <br />
            <p>
              <strong>Dirección: </strong>
              <Input
                value={direccion}
                onChange={(e) => setDireccion(e.target.value)}
                placeholder="Ingrese la dirección"
                style={{ display: "inline-block", width: "300px", marginLeft: "10px" }}
              />
            </p>
            <p>
              <strong>Ciudad: </strong>
              <Input
                value={ciudad}
                onChange={(e) => setCiudad(e.target.value)}
                placeholder="Ingrese ciudad"
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
            </p>

            {ciudadNormalizada === "MEDELLIN" && (
              <div>
                <strong>Comuna: </strong>
                <Input
                  value={comuna}
                  onChange={(e) => setComuna(e.target.value)}
                  placeholder="Ingrese comuna"
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
              </div>
            )}
            <p>
              <strong>Correo electrónico: </strong>
              <Input
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="Ingrese correo electrónico"
                style={{ display: "inline-block", width: "250px", marginLeft: "10px" }}
              />
            </p>
            <p>
              <strong>Teléfono: </strong>
              <Input
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                placeholder="Ingrese teléfono"
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
            </p>

            <br />

            <p className="text-right">
              En constancia, se firma en {fechaFirma || obtenerFechaFormateada()}
              <img
                src={preview}
                style={{
                  height: "50%",
                  width: "50%",
                  borderTop: "none",
                }}
              alt="Firma"
              />
            </p>
          </div>
        </div>
        <div className="acciones-documento">
          {/* Columna 1*/}
          <div className="accion-firma">
            <span className="asgevl_form_lable">
              Actualizar firma:
            </span>

            <input
              ref={fileInputRef}
              type="file"
              onChange={selectFile}
            />
          </div>

          {/* Columna 2*/}
          <div className="accion-botones">
            <button
              className="button-azul-radius font-size-16px"
              disabled={loadingDeclaracion}
              onClick={firmarDeclaracion}>Guardar documento</button>
          </div>
        </div>

      </Modal>
      <Modal
        style={{ top: 20, zIndex: 3 }}
        visible={openRelacionParticipantesModal}
        footer={null}
        width={900}
        maskClosable={true}
        onCancel={() => setOpenRelacionParticipantesModal(false)}
        maskStyle={{
          zIndex: 3,
          background: "rgb(12, 164, 93)",
        }}
        className="modal-postulacion-exitosa"
      >
        <div className="document-wrapper">
          <div id="modal_custom" className="document-page">
            <h3 className="text-center">
              RELACIÓN DE PARTICIPANTES DE LA PROPUESTA
            </h3>
            <p className="text-justify">
              Señores, <br />
              <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
              Secretaría de Cultura Ciudadana <br />
              Alcaldía de Medellín <br />
              Distrito de Ciencia, Tecnología e Innovación
            </p>
            <p className="text-justify">
              <strong>
                Asunto: Relación de participantes para propuestas de personas jurídicas
              </strong>
            </p>
            <p className="text-justify">
              A continuación, relacionamos las personas que desarrollarán la propuesta {" "}
              <strong>{datosEmpresaParsed?.razon_social}</strong> presentada en la {" "}
              <strong>{getFilterLineaConvocatoria(convocatoria.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(convocatoria.linea_convocatoria)}` : ""}</strong>.
            </p>
            <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '13px' }}>
              <InfoCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
              <strong>Nota:</strong> El primer participante que se agrega se considera el representante.
            </div>
            <div>
              {participantes && Array.isArray(participantes) && participantes.length > 0 ? (
                <div style={{ fontSize: '9px', marginTop: '20px' }}>
                  {participantes.map((p, index) => {
                    return (
                      <div
                        key={p.numeroDocumento || p.nombresApellidos}
                        style={{
                          border: '1px solid #ddd',
                          padding: '15px',
                          marginBottom: '10px',
                          borderRadius: '4px',
                          backgroundColor: '#fafafa',
                          position: 'relative'
                        }}
                      >
                        <Button
                          type="text"
                          danger
                          icon={<DeleteOutlined />}
                          style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1 }}
                          onClick={() => eliminarParticipante(index)}
                        />
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '11px' }}>
                          <div><strong>Nombres:</strong> <Input size="small" value={p.nombresApellidos} onChange={(e) => handleParticipantDataChange(index, 'nombresApellidos', e.target.value)} /></div>
                          <div><strong>Rol:</strong> <Input size="small" value={p.rol} onChange={(e) => handleParticipantDataChange(index, 'rol', e.target.value)} /></div>
                          <p className="text-justify" style={{ gridColumn: 'span 2' }}>
                            <strong>Tipo de documento: </strong>
                            <Radio.Group
                              value={p.tipoDocumento}
                              onChange={(e) => handleParticipantDataChange(index, 'tipoDocumento', e.target.value)}
                            >
                              <Radio value="CC">CC</Radio>
                              <Radio value="CE">CE</Radio>
                              {convocatoria.menor_edad && (
                                <Radio value="TI">TI</Radio>
                              )}
                            </Radio.Group>
                          </p>
                          <div><strong>N° Doc:</strong> <Input size="small" value={p.numeroDocumento} onChange={(e) => handleParticipantDataChange(index, 'numeroDocumento', e.target.value)} /></div>
                          <p className="text-justify">
                            <strong>Fecha de nacimiento:</strong>
                            <DatePicker
                              value={p.fechaNacimiento ? moment(p.fechaNacimiento) : null}
                              disabledDate={disabledFechaNacimiento}
                              style={{ width: '100%' }}
                              onChange={(date) => handleParticipantDataChange(index, 'fechaNacimiento', date)}
                              format="YYYY-MM-DD"
                              locale={locale}
                            />
                            {!convocatoria.menor_edad && p.edadCumplida !== "" && p.edadCumplida < 18 && (
                              <small style={{ color: "#faad14" }}>
                                {" "}No se permiten menores de 18 años
                              </small>
                            )}
                          </p>
                          <div><strong>Edad:</strong> <Input size="small" value={p.edadCumplida} readOnly disabled /></div>
                          <div><strong>Dirección:</strong> <Input size="small" value={p.direccionResidencia} onChange={(e) => handleParticipantDataChange(index, 'direccionResidencia', e.target.value)} /></div>
                          <div><strong>Ciudad:</strong> <Input size="small" value={p.ciudad} onChange={(e) => handleParticipantDataChange(index, 'ciudad', e.target.value)} /></div>
                          <div><strong>Tel. Fijo:</strong> <Input size="small" value={p.telefonoFijo} onChange={(e) => handleParticipantDataChange(index, 'telefonoFijo', e.target.value)} /></div>
                          <div><strong>Tel. Celular:</strong> <Input size="small" value={p.telefonoCelular} onChange={(e) => handleParticipantDataChange(index, 'telefonoCelular', e.target.value)} /></div>
                          <div><strong>Tiempo Residencia (Años):</strong> <Input type="number" size="small" value={p.tiempoResidencia} onChange={(e) => handleParticipantDataChange(index, 'tiempoResidencia', e.target.value)} /></div>
                          <div><strong>Correo:</strong> <Input size="small" value={p.correoElectronico} onChange={(e) => handleParticipantDataChange(index, 'correoElectronico', e.target.value)} /></div>
                        </div>
                        {p.preview && (
                          <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                            <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                            <img
                              src={p.preview}
                              alt={`Firma de ${p.nombresApellidos || 'participante'}`}
                              style={{
                                maxWidth: '100px',
                                maxHeight: '50px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '2px',
                                backgroundColor: '#fff'
                              }}
                            />
                          </div>
                        )}
                        <div style={{ marginTop: '8px', textAlign: 'center' }}>
                          <span style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>Cargar firma:</span>
                          <input
                            type="file"
                            accept="image/png, image/jpeg, .jfif"
                            style={{ fontSize: '9px' }}
                            onChange={(e) => handleParticipantSignatureChange(index, e)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-justify" style={{ fontSize: '12px' }}>
                  No hay participantes registrados.
                </p>
              )}
              <Button type="dashed" onClick={agregarNuevoParticipante} icon={<PlusOutlined />} style={{ width: '100%', marginBottom: '20px' }}>
                Agregar participante
              </Button>
            </div>
            {participantes.length > 0 && (
              <p className="text-right">
                En constancia, se firma en Medellín a los {fechaFirma || obtenerFechaFormateada()}.
                <br />
                <br />
                <br />
                <img
                  src={participantes[0]?.preview}
                  style={{
                    height: "50px",
                    width: "auto",
                    borderTop: "none",
                  }}
              alt="Firma"
              />
                <br />
                <strong>
                  {participantes[0]?.nombresApellidos}
                </strong>
                <br />
                Representante legal
              </p>
            )}
          </div>
        </div>
        <div className="acciones-documento justify-content-center">
          <div className="">
            <button
              className="button-azul-radius font-size-16px"
              disabled={loadingRelacion}
              onClick={firmarRelacion}>Guardar documento</button>
          </div>
        </div>
      </Modal>
      {/* carta de conformación de grupo */}
      <Modal
        style={{ top: 20, zIndex: 3 }}
        visible={openRelacionCartaConformacionModal}
        footer={null}
        width={900}
        maskClosable={true}
        onCancel={() => setOpenRelacionCartaConformacionModal(false)}
        maskStyle={{
          zIndex: 3,
          background: "rgb(12, 164, 93)",
        }}
        className="modal-postulacion-exitosa"
      >
        <div className="document-wrapper">
          <div id="modal_custom" className="document-page">
            <h3 className="text-center">
              CARTA DE CONFORMACIÓN DE GRUPO
            </h3>
            <p className="text-justify">
              Señores, <br />
              <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
              Secretaría de Cultura Ciudadana <br />
              Alcaldía de Medellín <br />
              Distrito de Ciencia, Tecnología e Innovación
            </p>
            <p className="text-justify">
              Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
              <strong>
                <Input
                  value={participante.nombreGrupo}
                  onChange={(e) => handleChange("nombreGrupo", e.target.value)}
                  placeholder="Ingrese grupo"
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
                {" "}
              </strong> y que hemos decidido participar en la línea {" "}
              <strong>{getFilterLineaConvocatoria(convocatoria.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(convocatoria.linea_convocatoria)}` : ""}</strong>. {" "}
              para lo cual afirmamos conocer las condiciones generales y específicas de participación.
            </p>
            <p className="text-justify">
              Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
              <strong> {participantes[0]?.nombresApellidos} </strong> {" "}
              identificado(a) con{" "}
              <strong> {participantes[0]?.tipoDocumento}</strong> número{" "}
              <strong> {participantes[0]?.numeroDocumento}</strong>, quien está expresamente facultado(a) para firmar,{" "}
              presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
              documentos necesarios y tomar todas las decisiones que fueren necesarias.
            </p>
            <p className="text-justify">
              Además, manifestamos bajo gravedad de juramento que ninguno de los integrantes del  grupo relacionados a continuación, incluido el representante, está incurso en las limitantes  establecidas en la convocatoria.
            </p>
            <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '13px' }}>
              <InfoCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
              <strong>Nota:</strong> El primer participante que se agrega se considera el representante.
            </div>
            <div>
              {participantes && Array.isArray(participantes) && participantes.length > 0 ? (
                <div style={{ fontSize: '9px', marginTop: '20px' }}>
                  {participantes.map((p, index) => {
                    return (
                      <div
                        key={p.numeroDocumento || p.nombresApellidos}
                        style={{
                          border: '1px solid #ddd',
                          padding: '15px',
                          marginBottom: '10px',
                          borderRadius: '4px',
                          backgroundColor: '#fafafa',
                          position: 'relative'
                        }}
                      >
                        <Button
                          type="text"
                          danger
                          icon={<DeleteOutlined />}
                          style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1 }}
                          onClick={() => eliminarParticipante(index)}
                        />
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '11px' }}>
                          <div><strong>Nombres:</strong> <Input size="small" value={p.nombresApellidos} onChange={(e) => handleParticipantDataChange(index, 'nombresApellidos', e.target.value)} /></div>
                          <div><strong>Rol:</strong> <Input size="small" value={p.rol} onChange={(e) => handleParticipantDataChange(index, 'rol', e.target.value)} /></div>
                          <p className="text-justify" style={{ gridColumn: 'span 2' }}>
                            <strong>Tipo de documento: </strong>
                            <Radio.Group
                              value={p.tipoDocumento}
                              onChange={(e) => handleParticipantDataChange(index, 'tipoDocumento', e.target.value)}
                            >
                              <Radio value="CC">CC</Radio>
                              <Radio value="CE">CE</Radio>
                              {convocatoria.menor_edad && (
                                <Radio value="TI">TI</Radio>
                              )}
                            </Radio.Group>
                          </p>
                          <div><strong>N° Doc:</strong> <Input size="small" value={p.numeroDocumento} onChange={(e) => handleParticipantDataChange(index, 'numeroDocumento', e.target.value)} /></div>
                          <p className="text-justify">
                            <strong>Fecha de nacimiento:</strong>
                            <DatePicker
                              value={p.fechaNacimiento ? moment(p.fechaNacimiento) : null}
                              disabledDate={disabledFechaNacimiento}
                              style={{ width: '100%' }}
                              onChange={(date) => handleParticipantDataChange(index, 'fechaNacimiento', date)}
                              format="YYYY-MM-DD"
                              locale={locale}
                            />
                            {!convocatoria.menor_edad && p.edadCumplida !== "" && p.edadCumplida < 18 && (
                              <small style={{ color: "#faad14" }}>
                                {" "}No se permiten menores de 18 años
                              </small>
                            )}
                          </p>
                          <div><strong>Edad:</strong> <Input size="small" value={p.edadCumplida} readOnly disabled /></div>
                          <div><strong>Dirección:</strong> <Input size="small" value={p.direccionResidencia} onChange={(e) => handleParticipantDataChange(index, 'direccionResidencia', e.target.value)} /></div>
                          <div><strong>Ciudad:</strong> <Input size="small" value={p.ciudad} onChange={(e) => handleParticipantDataChange(index, 'ciudad', e.target.value)} /></div>
                          <div><strong>Tel. Fijo:</strong> <Input size="small" value={p.telefonoFijo} onChange={(e) => handleParticipantDataChange(index, 'telefonoFijo', e.target.value)} /></div>
                          <div><strong>Tel. Celular:</strong> <Input size="small" value={p.telefonoCelular} onChange={(e) => handleParticipantDataChange(index, 'telefonoCelular', e.target.value)} /></div>
                          <div><strong>Tiempo Residencia (Años):</strong> <Input type="number" size="small" value={p.tiempoResidencia} onChange={(e) => handleParticipantDataChange(index, 'tiempoResidencia', e.target.value)} /></div>
                          <div><strong>Correo:</strong> <Input size="small" value={p.correoElectronico} onChange={(e) => handleParticipantDataChange(index, 'correoElectronico', e.target.value)} /></div>
                        </div>
                        {p.preview && (
                          <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                            <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                            <img
                              src={p.preview}
                              alt={`Firma de ${p.nombresApellidos || 'participante'}`}
                              style={{
                                maxWidth: '100px',
                                maxHeight: '50px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '2px',
                                backgroundColor: '#fff'
                              }}
                            />
                          </div>
                        )}
                        <div style={{ marginTop: '8px', textAlign: 'center' }}>
                          <span style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>Cargar firma:</span>
                          <input
                            type="file"
                            accept="image/png, image/jpeg, .jfif"
                            style={{ fontSize: '9px' }}
                            onChange={(e) => handleParticipantSignatureChange(index, e)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-justify" style={{ fontSize: '12px' }}>
                  No hay participantes registrados.
                </p>
              )}
              <Button type="dashed" onClick={agregarNuevoParticipante} icon={<PlusOutlined />} style={{ width: '100%', marginBottom: '20px' }}>
                Agregar participante
              </Button>
            </div>
            {participantes.length > 0 && (
              <p className="text-right">
                En constancia, se firma en Medellín a los {fechaFirma || obtenerFechaFormateada()}.
                <br />
                <br />
                <br />
                <img
                  src={participantes[0]?.preview}
                  style={{
                    height: "50px",
                    width: "auto",
                    borderTop: "none",
                  }}
              alt="Firma"
              />
                <br />
                <strong>
                  {participantes[0]?.nombresApellidos}
                </strong>
                <br />
                Representante del grupo
              </p>
            )}
          </div>
        </div>
        <div className="acciones-documento justify-content-center">
          <div className="">
            <button
              className="button-azul-radius font-size-16px"
              disabled={loadingCartaConformacion}
              onClick={firmarCartaConformacion}>Guardar documento</button>
          </div>
        </div>
      </Modal>
      {/* Declaracion Grupo conformado */}
      < Modal
        style={{ top: 20, zIndex: 3 }}
        visible={openDeclaracionGCModal}
        footer={null}
        width={900}
        maskClosable={true}
        onCancel={() => setOpenDeclaracionGCModal(false)}
        maskStyle={{
          zIndex: 3,
          background: "rgb(12, 164, 93)",
        }}
        className="modal-postulacion-exitosa"
      >
        <div className="document-wrapper">
          <div id="modal_custom" className="document-page">
            <h3 className="text-center">
              DECLARACIÓN JURAMENTADA DE RESIDENCIA PARA GRUPOS CONFORMADOS
            </h3>
            <p className="text-justify">
              Señores, <br />
              <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
              Secretaría de Cultura Ciudadana <br />
              Alcaldía de Medellín <br />
              Distrito de Ciencia, Tecnología e Innovación
            </p>
            <p className="text-justify">
              Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
              <strong>
                <Input
                  value={participante.nombreGrupo}
                  onChange={(e) => handleChange("nombreGrupo", e.target.value)}
                  placeholder="Ingrese nombre de grupo"
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
                {" "}
              </strong> y que hemos decidido participar en la línea {" "}
              <strong>{getFilterLineaConvocatoria(convocatoria.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(convocatoria.linea_convocatoria)}` : ""}</strong>. {" "}
              para lo cual afirmamos conocer las condiciones generales y específicas de participación.
            </p>
            <p className="text-justify">
              Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
              <strong> {participantes[0]?.nombresApellidos}</strong> {" "}
              identificado(a) con{" "}
              <strong> {participantes[0]?.tipoDocumento}</strong> número{" "}
              <strong> {participantes[0]?.numeroDocumento}</strong>, quien está expresamente facultado(a) para firmar,{" "}
              presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
              documentos necesarios y tomar todas las decisiones que fueren necesarias.
            </p>
            <p>
              También, manifestamos que ninguno de los integrantes del grupo está incurso en las limitantes establecidas en la convocatoria.
            </p>
            <p className="text-justify">
              Además, los abajo firmantes, manifestamos la bajo gravedad de juramento, que nuestros lugares de residencia son los que se relacionan a continuación:
            </p>
            <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '13px' }}>
              <InfoCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
              <strong>Nota:</strong> El primer participante que se agrega se considera el representante.
            </div>
            <div>
              {participantes && Array.isArray(participantes) && participantes.length > 0 ? (
                <div style={{ fontSize: '9px', marginTop: '20px' }}>
                  {participantes.map((p, index) => {
                    return (
                      <div
                        key={p.numeroDocumento || p.nombresApellidos}
                        style={{
                          border: '1px solid #ddd',
                          padding: '15px',
                          marginBottom: '10px',
                          borderRadius: '4px',
                          backgroundColor: '#fafafa',
                          position: 'relative'
                        }}
                      >
                        <Button
                          type="text"
                          danger
                          icon={<DeleteOutlined />}
                          style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1 }}
                          onClick={() => eliminarParticipante(index)}
                        />
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '11px' }}>
                          <div><strong>Nombres:</strong> <Input size="small" value={p.nombresApellidos} onChange={(e) => handleParticipantDataChange(index, 'nombresApellidos', e.target.value)} /></div>
                          <div><strong>Rol:</strong> <Input size="small" value={p.rol} onChange={(e) => handleParticipantDataChange(index, 'rol', e.target.value)} /></div>
                          <p className="text-justify" style={{ gridColumn: 'span 2' }}>
                            <strong>Tipo de documento: </strong>
                            <Radio.Group
                              value={p.tipoDocumento}
                              onChange={(e) => handleParticipantDataChange(index, 'tipoDocumento', e.target.value)}
                            >
                              <Radio value="CC">CC</Radio>
                              <Radio value="CE">CE</Radio>
                              {convocatoria.menor_edad && (
                                <Radio value="TI">TI</Radio>
                              )}
                            </Radio.Group>
                          </p>
                          <div><strong>N° Doc:</strong> <Input size="small" value={p.numeroDocumento} onChange={(e) => handleParticipantDataChange(index, 'numeroDocumento', e.target.value)} /></div>
                          <p className="text-justify">
                            <strong>Fecha de nacimiento:</strong>
                            <DatePicker
                              value={p.fechaNacimiento ? moment(p.fechaNacimiento) : null}
                              disabledDate={disabledFechaNacimiento}
                              style={{ width: '100%' }}
                              onChange={(date) => handleParticipantDataChange(index, 'fechaNacimiento', date)}
                              format="YYYY-MM-DD"
                              locale={locale}
                            />
                            {!convocatoria.menor_edad && p.edadCumplida !== "" && p.edadCumplida < 18 && (
                              <small style={{ color: "#faad14" }}>
                                {" "}No se permiten menores de 18 años
                              </small>
                            )}
                          </p>
                          <div><strong>Edad:</strong> <Input size="small" value={p.edadCumplida} readOnly disabled /></div>
                          <div><strong>Dirección:</strong> <Input size="small" value={p.direccionResidencia} onChange={(e) => handleParticipantDataChange(index, 'direccionResidencia', e.target.value)} /></div>
                          <div><strong>Ciudad:</strong> <Input size="small" value={p.ciudad} onChange={(e) => handleParticipantDataChange(index, 'ciudad', e.target.value)} /></div>
                          <div><strong>Tel. Fijo:</strong> <Input size="small" value={p.telefonoFijo} onChange={(e) => handleParticipantDataChange(index, 'telefonoFijo', e.target.value)} /></div>
                          <div><strong>Tel. Celular:</strong> <Input size="small" value={p.telefonoCelular} onChange={(e) => handleParticipantDataChange(index, 'telefonoCelular', e.target.value)} /></div>
                          <div><strong>Tiempo Residencia (Años):</strong> <Input type="number" size="small" value={p.tiempoResidencia} onChange={(e) => handleParticipantDataChange(index, 'tiempoResidencia', e.target.value)} /></div>
                          <div><strong>Correo:</strong> <Input size="small" value={p.correoElectronico} onChange={(e) => handleParticipantDataChange(index, 'correoElectronico', e.target.value)} /></div>
                        </div>
                        {p.preview && (
                          <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                            <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                            <img
                              src={p.preview}
                              alt={`Firma de ${p.nombresApellidos || 'participante'}`}
                              style={{
                                maxWidth: '100px',
                                maxHeight: '50px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '2px',
                                backgroundColor: '#fff'
                              }}
                            />
                          </div>
                        )}
                        <div style={{ marginTop: '8px', textAlign: 'center' }}>
                          <span style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>Cargar firma:</span>
                          <input
                            type="file"
                            accept="image/png, image/jpeg, .jfif"
                            style={{ fontSize: '9px' }}
                            onChange={(e) => handleParticipantSignatureChange(index, e)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-justify" style={{ fontSize: '12px' }}>
                  No hay participantes registrados.
                </p>
              )}
              <Button type="dashed" onClick={agregarNuevoParticipante} icon={<PlusOutlined />} style={{ width: '100%', marginBottom: '20px' }}>
                Agregar participante
              </Button>
            </div>
            {participantes.length > 0 && (
              <p className="text-right">
                En constancia, se firma en Medellín a los {fechaFirma || obtenerFechaFormateada()}.
                <br />
                <br />
                <br />
                <img
                  src={participantes[0]?.preview}
                  style={{
                    height: "50px",
                    width: "auto",
                    borderTop: "none",
                  }}
              alt="Firma"
              />
                <br />
                <strong>
                  {participantes[0]?.nombresApellidos}
                </strong>
                <br />
                Representante del grupo
              </p>
            )}
          </div>
        </div>
        <div className="acciones-documento justify-content-center">
          <div className="">
            <button
              className="button-azul-radius font-size-16px"
              disabled={loadingDeclaracionGC}
              onClick={firmarDeclaracionGC}>Guardar documento</button>
          </div>
        </div>
      </Modal>

    </div >
  );
};
